import i18next, { type i18n as I18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

/** The host owns the i18next instance; the package adds its bundle through the module gate. */
export function createHostI18n(): I18n {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    resources: {
      en: {
        host: {
          notFound: 'Page not found',
          noAccess: 'You do not have access to this page.',
          loading: 'Loading…',
          signingIn: 'Signing in…',
        },
      },
    },
    defaultNS: 'host',
    interpolation: { escapeValue: false },
  });
  return instance;
}
